import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, ArrowLeft, MapPin, Clock } from 'lucide-react';
import { Button } from '../components/ui/button';

export const ShippingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50/50 to-white">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-[#7d1f3d]">
              CurveeForYou
            </Link>
            <Link to="/">
              <Button variant="outline" className="border-[#7d1f3d] text-[#7d1f3d] hover:bg-[#7d1f3d] hover:text-white">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Shop
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="text-5xl font-bold text-[#7d1f3d] mb-6">Shipping Information</h1>
        <p className="text-xl text-gray-600 mb-12">Fast, reliable delivery to your door</p>

        <div className="space-y-8">
          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <div className="flex items-start gap-4">
              <div className="bg-[#7d1f3d]/10 p-3 rounded-lg">
                <MapPin className="w-6 h-6 text-[#7d1f3d]" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#7d1f3d] mb-3">Shipping Locations</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  <strong>United States:</strong> We offer FREE shipping to all 50 states.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  <strong>Canada:</strong> We ship to all Canadian provinces. Shipping fees are calculated at checkout based on your location.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <div className="flex items-start gap-4">
              <div className="bg-[#7d1f3d]/10 p-3 rounded-lg">
                <Clock className="w-6 h-6 text-[#7d1f3d]" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#7d1f3d] mb-3">Delivery Times</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  <strong>US Orders:</strong> Typically 3-5 business days from order placement
                </p>
                <p className="text-gray-600 leading-relaxed">
                  <strong>Canadian Orders:</strong> Typically 7-10 business days from order placement
                </p>
                <p className="text-sm text-gray-500 mt-4">
                  Note: Delivery times may vary during holidays or peak seasons. You will receive a tracking number via email once your order ships.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <div className="flex items-start gap-4">
              <div className="bg-[#7d1f3d]/10 p-3 rounded-lg">
                <Truck className="w-6 h-6 text-[#7d1f3d]" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#7d1f3d] mb-3">Shipping Policy</h2>
                <ul className="space-y-2 text-gray-600">
                  <li>• Orders are processed within 1-2 business days</li>
                  <li>• You will receive a confirmation email with tracking information</li>
                  <li>• Free US shipping on all orders</li>
                  <li>• We ship Monday through Friday (excluding holidays)</li>
                  <li>• PO Boxes are accepted for US orders</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="bg-[#7d1f3d] text-white py-8 mt-16">
        <div className="container mx-auto px-6 text-center">
          <div className="flex flex-wrap justify-center gap-6 mb-4">
            <Link to="/faq" className="hover:text-[#d4af37] transition-colors">FAQ</Link>
            <Link to="/shipping" className="hover:text-[#d4af37] transition-colors">Shipping</Link>
            <Link to="/returns" className="hover:text-[#d4af37] transition-colors">Returns</Link>
            <Link to="/size-guide" className="hover:text-[#d4af37] transition-colors">Size Guide</Link>
            <Link to="/contact" className="hover:text-[#d4af37] transition-colors">Contact</Link>
          </div>
          <div className="text-sm opacity-90 mb-3 leading-relaxed">
            <p className="font-semibold mb-1">CurveeForYou</p>
            <p>1209 Mountain Road Place Northeast, Suite N</p>
            <p>Albuquerque, NM 87110, United States</p>
            <p className="mt-2">
              <a href="tel:+18002985173" className="hover:text-[#d4af37] transition-colors">Tel: 800 298 5173</a>
              {' · '}
              <a href="mailto:info@curveeforyou.com" className="hover:text-[#d4af37] transition-colors">info@curveeforyou.com</a>
            </p>
          </div>
          <p className="text-sm opacity-80">© 2025 CurveeForYou. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};